import { PointOfInterest } from '../../core/models';

const ActionTypes = {
  LOAD_POI: `[POI] Load POI`,
  LOAD_POI_SUCCESS: `[POI] Load POI Success`,
  LOAD_POI_FAIL: `[POI] Load POI Fail`,

  SAVE_POI: `[POI] Save POI`,
  SAVE_POI_SUCCESS: `[POI] Save POI Success`,
  SAVE_POI_FAIL: `[POI] Save POI Fail`,

  DELETE_POI: `[POI] Delete POI`,
  DELETE_POI_SUCCESS: `[POI] Delete POI Success`,
  DELETE_POI_FAIL: `[POI] Delete POI Fail`,
};

export class LoadPoiAction {
  static type = ActionTypes.LOAD_POI;

  constructor(public payload?: any) {
  }
}
export class LoadPoiSuccessAction {
  static type = ActionTypes.LOAD_POI_SUCCESS;

  constructor(public payload: PointOfInterest[]) {
  }
}
export class LoadPoiFailAction {
  static type = ActionTypes.LOAD_POI_FAIL;

  constructor(public payload: any) {
  }
}




export class SavePoiAction {
  static type = ActionTypes.SAVE_POI;

  constructor(public payload: PointOfInterest) {
  }
}
export class SavePoiSuccessAction {
  static type = ActionTypes.SAVE_POI_SUCCESS;

  constructor(public payload: PointOfInterest) {
  }
}
export class SavePoiFailAction {
  static type = ActionTypes.SAVE_POI_FAIL;

  constructor(public payload: any) {
  }
}




export class DeletePoiAction {
  static type = ActionTypes.DELETE_POI;

  constructor(public payload: number) {
  }
}
export class DeletePoiSuccessAction {
  static type = ActionTypes.DELETE_POI_SUCCESS;

  constructor(public payload: number) {
  }
}
export class DeletePoiFailAction {
  static type = ActionTypes.DELETE_POI_FAIL;

  constructor(public payload: any) {
  }
}
